<template lang="pug">
  #InvitationIndex.container-width
    h5.pt-2 邀請函預覽

    .m-3
      h4.text-center {{ invitation.invite_title }}
      img.img-fluid.w-100.h-100.rounded(:src="invitation.invite_picture_url")
      .mt-3.text-center(v-html='invitation.invite_content')
</template>

<script>

export default {
  name: 'InvitationPreview',
  props: {
    invitation: {
      type: [Object],
      required: true
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<style>

</style>
